export default __webpack_public_path__ + "static/media/spain.0b550589.svg";